import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { createPortal } from "react-dom";

// import Papa from "papaparse";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { Container } from "react-bootstrap";
import { useNavigate, useNavigationType } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useLoader } from "../../context/LoaderContext";
import NpaListSection from "./NpaListSection";
import NpaAddImpExprtBtn from "./NpaAddImpExprtBtn";
import { deleteProperty, exportNpaList, importBankUserList, npaProperties, npaStatsProperties, propertyTypesDropdown, reqToImportNpaProperties, } from "../../redux/slice/propertiesSlice";
import { mapToSelectOptions } from "../../utils/otherHelopers";
import DeletePopup from "../../components/delete-popup";
import ImportModal from "../../components/modals/ImportModal";
import { ExpiredPropertyIcon, PublishedIcon, NpaPropertyIcon, PendingIcon } from "../../assets/icons";
import { useToast } from "../../context/TostContext";
import FilterModal from "../../components/FilterModal/FilterModal";
import { usePermission } from "../../hooks/usePermission";
import { TabCard } from "../../components/custom-card/Cards";

const MODULE_SLUG = "npa_properties";

export default function List() {
  const navigate = useNavigate();
  const navigationType = useNavigationType();
  const dispatch = useDispatch();
  const { setLoading } = useLoader();
  const headerPortalTarget = document.getElementById("header-portal-target");

  const headerContent = (
    <div className="d-flex align-items-center justify-content-between w-100">
      <h4 className="fw-semibold mb-0 text-primary fs-lg">
        <span className="text-muted fw-normal">NPA / </span>NPA Properties
      </h4>
    </div>
  );
  const { hasPermission } = usePermission();
  const toast = useToast();
  const canCreate = hasPermission(MODULE_SLUG, "create");
  const canUpdate = hasPermission(MODULE_SLUG, "update");
  const canDelete = hasPermission(MODULE_SLUG, "delete");
  const canExport = hasPermission(MODULE_SLUG, "export");


  // Pagination
  const [limit, setLimit] = useState(() => {
    if (navigationType === "POP") {
      const savedLimit = sessionStorage.getItem("npaProperties_limit");
      if (savedLimit) return JSON.parse(savedLimit);
    }
    return { value: 10, label: 10 };
  });
  const [currentPage, setCurrentPage] = useState(() => {
    if (navigationType === "POP") {
      const savedPage = sessionStorage.getItem("npaProperties_page");
      if (savedPage) return parseInt(savedPage, 10);
    }
    return 1;
  });


  // Delete Property, Modal state
  const [openDeletePropertyModal, setOpenDeletePropertyModal] = useState(false);
  const [selectedDeleteProperty, setSelectedDeleteProperty] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  // Card Status
  const [cardStatus, setCardStatus] = useState(() => {
    if (navigationType === "POP") {
      return sessionStorage.getItem("npaProperties_cardStatus") || "";
    }
    return "";
  });
  // Add or Edit Form
  const [isEdit, setIsEdit] = useState(false);
  // Filter Modal State
  const [filterModal, setFilterModal] = useState(false);
  const [filterValues, setFilterValues] = useState(() => {
    const searchValue =
      navigationType === "POP"
        ? sessionStorage.getItem("npaProperties_searchTerm") || ""
        : "";

    let filValues = {};
    if (navigationType === "POP") {
      const stored = sessionStorage.getItem("npaProperties_filterValues");
      if (stored) {
        try {
          filValues = JSON.parse(stored);
        } catch (e) {
          console.error("Failed to parse filter values", e);
        }
      }
    }

    console.log("filterValues 123", filValues);

    return {
      search: searchValue,
      asset: filValues?.asset || "",
      property: filValues?.property || [],
      possession: filValues?.possession || [],
      city: filValues?.city || "",
      reservePrice: filValues?.reservePrice || "",
      land_types: filValues?.land_types || [],
    };
  });
  console.log("npaFilter123", filterValues);

  // Open Modal for Import
  const [openImportModal, setOpenImportModal] = useState(false);
  // Options for filters dropdown
  const [assetOptions, setAssetOptions] = useState();
  const [propertyOptions, setPropertyOptions] = useState();
  const [possessionOptions, setPossessionOptions] = useState();
  const [cityOptions, setCityOptions] = useState();
  const [reservePriceOptions, setReservePriceOptions] = useState();

  const [dropdownData, setDropdownData] = useState({
    propertyTypes: [],
    assetCategories: [],
    possessionTypes: [],
    auctionTypes: [],
  });

  const importModalUsersList = useSelector((state) => state?.property?.bankUsersList);
  // console.log("importModalUsersList", importModalUsersList);

  const importModalUsers = importModalUsersList?.map((user) => ({
    id: user?.id,
    value: user?.id,
    label: user?.name,
    bankName: user?.bank?.name,
    branchName: user?.branch?.name,
    city: user?.branch?.city,
  }))




  const { property: properties, isLoading } = useSelector((state) => state?.property);


  const totalProperties = properties?.meta?.total;

  const statusCounts = useSelector(
    (state) => state?.property?.npaStats
  );

  const NpaPropertiesCard = [
    { id: 1, total: statusCounts?.total || 0, title: "All Property", icon: <NpaPropertyIcon className="secondary" />, status: "", iconClassName: "icon-secondary" },
    { id: 2, total: statusCounts?.live || 0, title: "Live Property", icon: <PublishedIcon className="text-success" />, status: "live", iconClassName: "icon-success" },
    { id: 3, total: statusCounts?.upcoming || 0, title: "Upcoming Property", icon: <PendingIcon />, status: "upcoming", iconClassName: "icon-warning" },
    { id: 4, total: statusCounts?.expired || 0, title: "Expired Property", icon: <ExpiredPropertyIcon className="text-danger" />, status: "expired", iconClassName: "icon-danger" },
  ];

  // status handler based on Card Click (APi will get call and display list based on status)
  const handleCardClick = (value) => {
    setCardStatus(value);
    setCurrentPage(1);
    setFilterValues({
      asset: "",
      property: "",
      possession: "",
      city: "",
      reservePrice: "",
      search: "",
    })
  };
  const isInitialLoadRef = useRef(true);
  const searchTimeout = useRef(null);
  const prevSearchRef = useRef(filterValues.search);

  const getAllNpaProperties = useCallback((isDebounced = false) => {
    if (isInitialLoadRef.current) {
      setLoading(true);
    }

    const params = {
      status: cardStatus,
      page: currentPage,
      limit: limit?.value,
      asset_category: filterValues?.asset,
      property_type: filterValues?.property,
      possession_type: filterValues?.possession,
      city_town: filterValues?.city,
      reserve_price: filterValues?.reservePrice,
      search: filterValues?.search
    };

    const fetchList = () => {
      dispatch(npaProperties(params))
        .finally(() => {
          if (isInitialLoadRef.current) {
            setLoading(false);
            isInitialLoadRef.current = false;
          }
        });
    };

    if (isDebounced) {
      if (searchTimeout.current) clearTimeout(searchTimeout.current);
      searchTimeout.current = setTimeout(fetchList, 500);
    } else {
      fetchList();
    }

    if (isInitialLoadRef.current) {
      dispatch(propertyTypesDropdown()).then((filterDataResponse) => {
        const data = filterDataResponse?.payload?.data;
        setAssetOptions(mapToSelectOptions(data?.asset_categories) || []);
        setPropertyOptions(mapToSelectOptions(data?.property_types) || []);
        setPossessionOptions(mapToSelectOptions(data?.possession_types) || []);
        setCityOptions(
          (data?.cities || []).map((city) => ({
            value: city,
            label: city,
          }))
        );
        setReservePriceOptions([
          {
            value: data?.reserve_price_range?.min || 0,
            label: `Min: ₹${data?.reserve_price_range?.min || 0}`,
          },
          {
            value: data?.reserve_price_range?.max || 0,
            label: `Max: ₹${data?.reserve_price_range?.max || 0}`,
          },
        ]);

        const formattedData = {
          propertyTypes: data?.property_types?.map(item => item?.name),
          assetCategories: data?.asset_categories?.map(item => item?.name),
          possessionTypes: data?.possession_types?.map(item => item?.name),
          auctionTypes: data?.auction_types?.map(item => item?.name),
        };
        setDropdownData(formattedData);
      });
    }

    sessionStorage.setItem("npaProperties_limit", JSON.stringify(limit));
    sessionStorage.setItem("npaProperties_page", currentPage.toString());
    sessionStorage.setItem("npaProperties_cardStatus", cardStatus);
    sessionStorage.setItem("npaProperties_searchTerm", filterValues.search);
    sessionStorage.setItem("npaProperties_filterValues", JSON.stringify(filterValues));

  }, [
    dispatch,
    setLoading,
    cardStatus,
    limit,
    currentPage,
    filterValues,
  ]);
  useEffect(() => {
    isInitialLoadRef.current = true;
  }, []);

  useEffect(() => {
    const isSearchChanged = prevSearchRef.current !== filterValues.search;
    prevSearchRef.current = filterValues.search;
    getAllNpaProperties(isSearchChanged);
  }, [getAllNpaProperties, filterValues.search]);

  useEffect(() => {
    dispatch(npaStatsProperties());
  }, [dispatch])




  const getCustomerActions = (item) => {
    const actions = [
      {
        title: "View",
        handler: () => navigate(`/npa-properties/property-details/${item.id}`),
      },
    ];

    if (canUpdate) {
      actions.push({
        title: "Edit",
        handler: () => handleEditBtn(item),
      });
    }

    if (canDelete) {
      actions.push({
        title: "Delete",
        handler: () => handlerDeleteProperty(item),
      });
    }

    return actions;
  };

  const handlerDeleteProperty = (item) => {
    setSelectedDeleteProperty(item);
    setOpenDeletePropertyModal(true);
  };

  // Main Handler for Deleting NPA Properties
  const handleConfirmDelete = () => {
    try {
      setLoading(true);
      setIsSubmitting(true);
      dispatch(deleteProperty({ id: selectedDeleteProperty?.id })).then(
        (res) => {
          if (res.payload.success) {
            toast.success(res?.payload?.msg || "Property deleted successfully");
            setOpenDeletePropertyModal(false);
            dispatch(npaProperties({})).then((res) => {
              setLoading(false);
            })
          }
        }
      );
    } catch (error) {
      toast.error(error?.msg || "Failed to delete Property");
      setLoading(false);
    } finally {
      setIsSubmitting(false);
      setOpenDeletePropertyModal(false);
    }
  };

  const handleEditBtn = (item) => {
    setIsEdit(true);
    navigate(`/npa-properties/edit/${item.id}`, {
      state: { item, isEdit: true },
    });
  };

  // Handler for Exporting NPA Properties
  const handleExportNpaProperties = async (status) => {

    try {
      setLoading(true);

      const blob = await dispatch(exportNpaList({ status })).unwrap();

      const url = window.URL.createObjectURL(
        new Blob([blob], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        })
      );

      const link = document.createElement("a");
      link.href = url;
      link.download = "NPA_Properties.xlsx";
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      toast.success("Export completed successfully");
    } catch (error) {
      toast.error("Failed to export data");
    } finally {
      setLoading(false);
    }
  };


  // Handler for downloading Sample CSV file
  // const downloadSampleCsvFile = (e) => {
  //   e.preventDefault();
  //   setLoading(true);
  //   const fileUrl = "/npaProperties.xlsx"; // Ensure this file is in the 'public' folder
  //   const link = document.createElement("a");
  //   link.href = fileUrl;
  //   link.setAttribute("download", "SampleTemplate(Npa-Properties).csv");
  //   document.body.appendChild(link);
  //   link.click();
  //   document.body.removeChild(link);
  //   URL.revokeObjectURL(fileUrl); 
  //   setLoading(false);
  // }
  // const downloadSampleCsvFile = async (e) => {
  //   e.preventDefault();

  //   const workbook = new ExcelJS.Workbook();
  //   const worksheet = workbook.addWorksheet("Sample");

  //   // Define headers
  //   const headers = [
  //     "asset_category",
  //     "property_type",
  //     "property_address",
  //     "province_state",
  //     "taluka",
  //     "city_town",
  //     "area_locality",
  //     "land_area",
  //     "builtup_carpet_area",
  //     "borrower_names",
  //     "possession_type",
  //     "reserve_price",
  //     "emd",
  //     "min_increment",
  //     "amount_outstanding",
  //     "dsc_required",
  //     "auction_type",
  //     "auction_start_time",
  //     "auction_end_time",
  //     "status",
  //     "description",
  //     "country",
  //     "contact_name",
  //     "contact_number",
  //     "time_extension",
  //     "application_submission_date",
  //     "property_inspection_datetime",
  //     "service_provider",
  //   ];

  //   worksheet.addRow(headers); // Add header row

  //   // Define dropdown options
  //   const dropdownOptions = {
  //     A: ["Residential", "Commercial", "Industrial", "Agricultural"], // asset_category
  //     K: ["Vacant", "Occupied", "Under Litigation"], // possession_type
  //   };

  //   // Apply dropdowns to specific columns
  //   Object.keys(dropdownOptions).forEach((colLetter) => {
  //     const colIndex = colLetter.charCodeAt(0) - 64; // Convert 'A' to 1, 'B' to 2, etc.

  //     worksheet.getColumn(colIndex).eachCell((cell, rowNumber) => {
  //       if (rowNumber > 1) { // Apply dropdowns to rows below headers
  //         cell.dataValidation = {
  //           type: "list",
  //           allowBlank: false,
  //           formulae: [`"${dropdownOptions[colLetter].join(",")}"`],
  //         };
  //       }
  //     });
  //   });

  //   // Generate Excel file and trigger download
  //   const buffer = await workbook.xlsx.writeBuffer();
  //   const fileData = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
  //   saveAs(fileData, "SampleTemplate(Npa-Properties).xlsx");
  // };

  // const downloadSampleCsvFile = async (e) => {
  //   e.preventDefault(); // Prevents default event behavior

  //   const workbook = new ExcelJS.Workbook();
  //   const worksheet = workbook.addWorksheet("Sample");

  //   // ✅ Static dropdown values
  //   const options1 = ["Select an option", "Option A1", "Option A2", "Option A3", "Option A4"];
  //   const options2 = ["Select an option", "Option B1", "Option B2", "Option B3"];

  //   // ✅ Add headers
  //   worksheet.addRow(["Name", "Category", "Type", "Location", "Status"]);

  //   // ✅ Set column widths
  //   worksheet.columns = [
  //     { header: "Name", key: "name", width: 20 },
  //     { header: "Category", key: "category", width: 25 },
  //     { header: "Type", key: "type", width: 25 },
  //     { header: "Location", key: "location", width: 20 },
  //     { header: "Status", key: "status", width: 25 },
  //   ];

  //   // ✅ Apply dropdowns to cells (Rows 2 to 50) with default "Select an option"
  //   for (let rowIndex = 2; rowIndex <= 50; rowIndex++) {
  //     const categoryCell = worksheet.getCell(`B${rowIndex}`);
  //     const typeCell = worksheet.getCell(`C${rowIndex}`);

  //     categoryCell.value = "Select"; // Set default placeholder
  //     typeCell.value = "Select"; // Set default placeholder

  //     categoryCell.dataValidation = {
  //       type: "list",
  //       allowBlank: false,
  //       formulae: [`"${options1.join(",")}"`],
  //     };

  //     typeCell.dataValidation = {
  //       type: "list",
  //       allowBlank: false,
  //       formulae: [`"${options2.join(",")}"`],
  //     };

  //     // ✅ Add light background for better visibility
  //     categoryCell.fill = {
  //       type: "pattern",
  //       pattern: "solid",
  //       fgColor: { argb: "FFFFFF" }, // Light orange
  //     };
  //     typeCell.fill = {
  //       type: "pattern",
  //       pattern: "solid",
  //       fgColor: { argb: "FFFFFF" }, // Light green
  //     };

  //     // ✅ Add border to dropdown cells
  //     [categoryCell, typeCell].forEach((cell) => {
  //       cell.border = {
  //         top: { style: "thin" },
  //         left: { style: "thin" },
  //         bottom: { style: "thin" },
  //         right: { style: "thin" },
  //       };
  //       cell.font = { bold: true, size: 12 }; // Bigger font for better visibility
  //     });
  //   }

  //   // ✅ Apply header styling
  //   worksheet.getRow(1).eachCell((cell) => {
  //     cell.font = { bold: true, color: { argb: "000000" } };
  //     cell.fill = {
  //       type: "pattern",
  //       pattern: "solid",
  //       fgColor: { argb: "FFD3D3D3" }, // Light gray background
  //     };
  //     cell.alignment = { horizontal: "center" };
  //   });

  //   // ✅ Generate and download Excel file
  //   const buffer = await workbook.xlsx.writeBuffer();
  //   const blob = new Blob([buffer], {
  //     type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  //   });

  //   saveAs(blob, "SampleTemplate.xlsx");
  // };
  // const downloadSampleCsvFile = async (e) => {
  //   e.preventDefault(); // Prevent default event behavior

  //   const workbook = new ExcelJS.Workbook();
  //   const worksheet = workbook.addWorksheet("Sample");

  //   // ✅ Dynamic dropdown values (Fixed)
  //   const optionsPropertyTypes = ["Select", ...dropdownData.propertyTypes];
  //   const optionsAssetCategories = ["Select", ...dropdownData.assetCategories];
  //   const optionsPossessionTypes = ["Select", ...dropdownData.possessionTypes];
  //   const optionsAuctionTypes = ["Select", ...dropdownData.auctionTypes];

  //   // ✅ Define headers
  //   const headers = [
  //     "asset_category", "property_type", "property_address", "province_state", "taluka", "city_town",
  //     "area_locality", "land_area", "builtup_carpet_area", "borrower_names", "possession_type",
  //     "reserve_price", "emd", "min_increment", "amount_outstanding", "dsc_required", "auction_type",
  //     "auction_start_time", "auction_end_time", "status", "description", "country", "contact_name",
  //     "contact_number", "time_extension", "application_submission_date", "property_inspection_datetime",
  //     "service_provider"
  //   ];

  //   // ✅ Add headers to the worksheet
  //   worksheet.addRow(headers);

  //   // ✅ Set column widths for better visibility
  //   worksheet.columns = headers.map(header => ({ header, key: header, width: 25 }));

  //   // ✅ Apply dropdowns to specific columns (Rows 2 to 50)
  //   for (let rowIndex = 2; rowIndex <= 10; rowIndex++) {
  //     const assetCategoryCell = worksheet.getCell(`A${rowIndex}`);
  //     const propertyTypeCell = worksheet.getCell(`B${rowIndex}`);
  //     const possessionTypeCell = worksheet.getCell(`K${rowIndex}`);
  //     const auctionTypeCell = worksheet.getCell(`Q${rowIndex}`);

  //     // Set default placeholder text
  //     assetCategoryCell.value = "Select";
  //     propertyTypeCell.value = "Select";
  //     possessionTypeCell.value = "Select";
  //     auctionTypeCell.value = "Select";

  //     // Apply dropdown validation
  //     assetCategoryCell.dataValidation = {
  //       type: "list",
  //       allowBlank: false,
  //       formulae: [`"${optionsAssetCategories.join(",")}"`],
  //     };
  //     propertyTypeCell.dataValidation = {
  //       type: "list",
  //       allowBlank: false,
  //       formulae: [`"${optionsPropertyTypes.join(",")}"`],
  //     };
  //     possessionTypeCell.dataValidation = {
  //       type: "list",
  //       allowBlank: false,
  //       formulae: [`"${optionsPossessionTypes.join(",")}"`],
  //     };
  //     auctionTypeCell.dataValidation = {
  //       type: "list",
  //       allowBlank: false,
  //       formulae: [`"${optionsAuctionTypes.join(",")}"`],
  //     };

  //     // Apply styling for better visibility
  //     [assetCategoryCell, propertyTypeCell, possessionTypeCell, auctionTypeCell].forEach(cell => {
  //       cell.fill = {
  //         type: "pattern",
  //         pattern: "solid",
  //         fgColor: { argb: "FFFFFF" }, // Light background
  //       };
  //       cell.border = {
  //         top: { style: "thin" },
  //         left: { style: "thin" },
  //         bottom: { style: "thin" },
  //         right: { style: "thin" },
  //       };
  //       cell.font = { bold: true, size: 12 };
  //     });
  //   }

  //   // ✅ Apply header styling
  //   worksheet.getRow(1).eachCell(cell => {
  //     cell.font = { bold: true, color: { argb: "000000" } };
  //     cell.fill = {
  //       type: "pattern",
  //       pattern: "solid",
  //       fgColor: { argb: "FFD3D3D3" }, // Light gray background
  //     };
  //     cell.alignment = { horizontal: "center" };
  //   });

  //   // ✅ Generate and download Excel file
  //   const buffer = await workbook.xlsx.writeBuffer();
  //   const blob = new Blob([buffer], {
  //     type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  //   });

  //   saveAs(blob, "SampleTemplate.xlsx");
  // };
  const downloadSampleCsvFile = async (e) => {
    e.preventDefault(); // Prevent default event behavior
    setLoading(true);

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Sample");

    // ✅ Dynamic dropdown values
    const optionsPropertyTypes = ["Select", ...dropdownData.propertyTypes];
    const optionsAssetCategories = ["Select", ...dropdownData.assetCategories];
    const optionsPossessionTypes = ["Select", ...dropdownData.possessionTypes];
    const optionsAuctionTypes = ["Select", ...dropdownData.auctionTypes];

    // ✅ Define headers
    // const headers = [
    //   "asset_category", "property_type", "property_address", "province_state", "taluka", "city_town",
    //   "area_locality", "land_area", "builtup_carpet_area", "borrower_names", "possession_type",
    //   "reserve_price", "emd", "min_increment", "amount_outstanding", "dsc_required", "auction_type",
    //   "auction_start_time", "auction_end_time", "description", "country", "contact_name",
    //   "contact_number", "time_extension", "application_submission_date", "property_inspection_datetime",
    //   "service_provider"
    // ];

    const headers = [
      "borrower_names",
      "property_type",
      "asset_category",
      "land_area",
      "carpet_area",
      "dsc_required",
      "possession_type",
      "auction_type",
      "auction_start_time",
      "auction_end_time",
      "property_inspection_date",
      "application_submission_date",
      "time_extension",
      "address_line_1",
      "area_locality",
      "taluka",
      "city",
      "state",
      "country",
      "service_provider",
      "emd",
      "reserve_price",
      "min_increment",
      "amount_outstanding",
      "contact_name",
      "contact_number",
    ];

    // ✅ Add headers to the worksheet
    worksheet.addRow(headers);

    // ✅ Set column widths for better visibility
    worksheet.columns = headers?.map(header => ({ header, key: header, width: 25 }));

    // ✅ Static values for other columns
    const staticValues = {
      address_line_1: "123 Main St",
      state: "Gujarat",
      taluka: "Varacha",
      city: "Surat",
      area_locality: "Katargam",
      land_area: "2000.00",
      carpet_area: "1500.00",
      borrower_names: "John Doe",
      reserve_price: "5000000.00",
      emd: "5000000.00",
      min_increment: "6000000.00",
      amount_outstanding: "8000000.00",
      dsc_required: "No",
      auction_start_time: "01/01/2025, 05:30 am",
      auction_end_time: "05/01/2020, 05:30 am",
      description: "Spacious house 3Bhk",
      country: "India",
      contact_name: "Manish Mehta",
      contact_number: "1234567890",
      time_extension: "10 min",
      application_submission_date: "06/01/2025, 05:30 am",
      property_inspection_date: "10/01/2025, 05:30 am",
      service_provider: "Mehta and Sons",
    };

    // ✅ Apply dropdowns & static values (Rows 2 to 10 only)
    for (let rowIndex = 2; rowIndex <= 10; rowIndex++) {
      const rowData = [];

      headers.forEach((header, index) => {
        if (header === "asset_category") {
          rowData[index] = "Select"; // Dropdown
        } else if (header === "property_type") {
          rowData[index] = "Select"; // Dropdown
        } else if (header === "possession_type") {
          rowData[index] = "Select"; // Dropdown
        } else if (header === "auction_type") {
          rowData[index] = "Select"; // Dropdown
        } else {
          rowData[index] = staticValues[header] || ""; // Static value
        }
      });

      worksheet.addRow(rowData);

      // ✅ Apply dropdown validation
      const propertyTypeCell = worksheet.getCell(`B${rowIndex}`);
      const assetCategoryCell = worksheet.getCell(`C${rowIndex}`);
      const possessionTypeCell = worksheet.getCell(`G${rowIndex}`);
      const auctionTypeCell = worksheet.getCell(`H${rowIndex}`);

      assetCategoryCell.dataValidation = {
        type: "list",
        allowBlank: false,
        formulae: [`"${optionsAssetCategories.join(",")}"`],
      };
      propertyTypeCell.dataValidation = {
        type: "list",
        allowBlank: false,
        formulae: [`"${optionsPropertyTypes.join(",")}"`],
      };
      possessionTypeCell.dataValidation = {
        type: "list",
        allowBlank: false,
        formulae: [`"${optionsPossessionTypes.join(",")}"`],
      };
      auctionTypeCell.dataValidation = {
        type: "list",
        allowBlank: false,
        formulae: [`"${optionsAuctionTypes.join(",")}"`],
      };

      // ✅ Apply styling for better visibility
      [propertyTypeCell, assetCategoryCell, possessionTypeCell, auctionTypeCell].forEach(cell => {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFFFFF" }, // Light background
        };
        cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };
        cell.font = { bold: true, size: 12 };
      });
    }

    // ✅ Apply header styling
    worksheet.getRow(1).eachCell(cell => {
      cell.font = { bold: true, color: { argb: "000000" } };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFD3D3D3" }, // Light gray background
      };
      cell.alignment = { horizontal: "center" };
    });

    // ✅ Generate and download Excel file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    saveAs(blob, "SampleTemplate.xlsx");

    setLoading(false);
  };

  // Import Btn Handler
  const importBtnHandler = () => {
    setOpenImportModal(true);
    dispatch(importBankUserList({
      page: currentPage,
      limit: limit?.value,
      search: filterValues.search,
    }));

  }

  // close Import Modal
  const handleImportSubmit = async (file, userId) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('bank_user_id', userId);
    setLoading(true);
    try {
      const result = await dispatch(reqToImportNpaProperties({ data: formData })).unwrap();
      if (result) {
        toast.success(result?.msg || "Properties Imported Successfully!");
        dispatch(npaProperties({
          status: cardStatus,
          page: currentPage,
          limit: limit?.value,
          asset_category: filterValues?.asset,
          property_type: filterValues?.property,
          possession_type: filterValues?.possession,
          city_town: filterValues?.city,
          reserve_price: filterValues?.reservePrice,
        }));
      }
    } catch (error) {
      let message = error?.message || "Failed to import properties";
      if (error?.data?.errors?.length) {
        const rowErrors = error.data.errors
          .map((e) => `Row ${e.row}: ${e.errors.join(", ")}`)
          .join("\n");
        message = `${message}\n${rowErrors}`;
      }
      throw new Error(message);
    } finally {
      setLoading(false);
    }
  };



  const paginationConfig = useMemo(() => ({
    currentPage,
    totalPages: Math.ceil(totalProperties / limit?.value) || 1,
    total: totalProperties || 0,
    onPageChange: (page) => setCurrentPage(page),
    pageSize: limit?.value,
    setPageSize: (size) => setLimit({ value: size, label: size }),
    setCurrentPage
  }), [currentPage, totalProperties, limit]);

  return (
    <>
      {headerPortalTarget && createPortal(headerContent, headerPortalTarget)}

      <Container fluid className="px-0">
        <div className="grid gap-4">
          {NpaPropertiesCard?.map((item, i) => (
            <TabCard
              key={i}
              className='g-col-4 g-col-xxl-3'
              count={item?.total}
              title={item?.title}
              icon={item?.icon}
              active={item.status === cardStatus}
              onClick={() => handleCardClick(item.status)}
              iconClassName={item?.iconClassName}
            />
          ))}
        </div>

        <div className="bg-white rounded-2 overflow-hidden common-shadow mt-4">
          {/* Export, Import, Add Btn Section */}
          <NpaAddImpExprtBtn
            navigate={navigate}
            filterValues={filterValues}
            setFilterModal={setFilterModal}
            setFilterValues={setFilterValues}
            importBtnHandler={importBtnHandler}
            setCurrentPage={setCurrentPage}
            handleExportNpaProperties={handleExportNpaProperties}
            totalProperties={properties?.data}
            cardStatus={cardStatus}
            canCreate={canCreate}
            canExport={canExport}
          />

          {/* List Section */}
          <NpaListSection
            isEdit={isEdit}
            data={properties?.data}
            navigate={navigate}
            currentPage={currentPage}
            getCustomerActions={getCustomerActions}
            isLoading={isLoading}
            isInitialLoad={isInitialLoadRef.current}
            pagination={paginationConfig}
          />
        </div>
      </Container>

      {/* Delete Modal */}
      <DeletePopup
        show={openDeletePropertyModal}
        onHide={() => setOpenDeletePropertyModal(false)}
        content="Are you sure you want to delete this Property?"
        removeTitle="Cancel"
        onConfirm={handleConfirmDelete}
        disabled={isSubmitting}
        saveTitle={isSubmitting ? "Deleting..." : "Delete"}
      />

      {/* Filter Modal */}
      <FilterModal
        isOpen={filterModal}
        size="lg"
        onClose={() => setFilterModal(false)}
        filterValues={filterValues}
        setFilterValues={setFilterValues}
        setCurrentPage={setCurrentPage}
        assetOptions={assetOptions}
        propertyOptions={propertyOptions}
        possessionOptions={possessionOptions}
        cityOptions={cityOptions}
        reservePriceOptions={reservePriceOptions}
        onClear={() => {
          setFilterValues({
            asset: "",
            property: "",
            possession: "",
            city: "",
            reservePrice: "",
            search: "",
          })
          setFilterModal(false)
        }}
      />


      <ImportModal
        isOpen={openImportModal}
        onClose={() => setOpenImportModal(false)}
        users={importModalUsers}
        onSubmit={handleImportSubmit}
        onDownloadSample={downloadSampleCsvFile}
        title="Import Properties"
      />
    </>
  );
}
